var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"compare-btn",class:_vm.classes},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.$t('common.add-to-compare'))+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }